// extracted by mini-css-extract-plugin
export default {"wrap":"HeaderBottom_wrap__lmluT","label":"HeaderBottom_label__ZUol9"};